/**
 * Airosa — asistente de dedicatorias · v2
 * Mejoras: tipografía móvil, reintento automático, jerarquía visual.
 */
(function () {
  var ENDPOINT = "https://aria-airosa.leninbayona5.workers.dev";
  var WHATSAPP = "https://wa.me/51932914677";

  var INK = "#1C1C1C", GOLD = "#FFAB40", CREAM = "#F6F1E8";
  var OCASIONES = ["Aniversario", "Mesario", "Cumpleaños", "Pedida", "Perdón", "Gracias", "Solo porque sí"];
  var TIMEOUT = 30000;

  var host = document.getElementById("airosa-dedicatoria");
  if (!host) return;

  var css = document.createElement("style");
  css.textContent = [
    "@import url('https://fonts.googleapis.com/css2?family=Jost:wght@300;400&family=Cormorant+Garamond:ital,wght@0,300;0,400;1,300;1,400&display=swap');",

    "#airosa-dedicatoria{font-family:Jost,system-ui,sans-serif;background:" + INK + ";background:linear-gradient(160deg,#232120 0%," + INK + " 55%);color:" + CREAM + ";padding:36px 26px 40px;margin:28px 0;box-sizing:border-box}",
    "#airosa-dedicatoria *{box-sizing:border-box}",

    ".ded-eyebrow{font-size:10px;font-weight:400;letter-spacing:.4em;text-transform:uppercase;color:rgba(255,171,64,.75)}",
    ".ded-title{font-family:'Cormorant Garamond',serif;font-weight:300;font-size:34px;line-height:1.12;margin:10px 0 10px;color:" + CREAM + "}",
    ".ded-sub{font-size:14px;font-weight:300;line-height:1.7;color:rgba(246,241,232,.55);max-width:46ch;margin-bottom:6px}",

    ".ded-label{display:block;font-size:10px;font-weight:400;letter-spacing:.3em;text-transform:uppercase;color:rgba(255,171,64,.55);margin:26px 0 10px}",

    ".ded-in,.ded-ta{width:100%;background:rgba(246,241,232,.04);border:none;border-bottom:1px solid rgba(246,241,232,.18);color:" + CREAM + ";font-family:Jost,sans-serif;font-weight:300;font-size:16px;padding:12px 12px;outline:none;transition:border-color .35s,background .35s;border-radius:0}",
    ".ded-in:focus,.ded-ta:focus{border-bottom-color:" + GOLD + ";background:rgba(246,241,232,.06)}",
    ".ded-ta{resize:vertical;min-height:76px;line-height:1.65}",
    ".ded-in::placeholder,.ded-ta::placeholder{color:rgba(246,241,232,.28)}",

    ".ded-ocs{display:flex;flex-wrap:wrap;gap:8px}",
    ".ded-oc{font-family:Jost,sans-serif;font-size:11px;font-weight:300;letter-spacing:.14em;text-transform:uppercase;padding:10px 15px;border:1px solid rgba(246,241,232,.18);background:none;color:rgba(246,241,232,.6);cursor:pointer;transition:all .3s;-webkit-tap-highlight-color:transparent}",
    ".ded-oc:hover{border-color:rgba(255,171,64,.5);color:rgba(246,241,232,.85)}",
    ".ded-oc.sel{border-color:" + GOLD + ";color:" + GOLD + ";background:rgba(255,171,64,.1)}",

    ".ded-go{margin-top:32px;width:100%;padding:17px;background:rgba(255,171,64,.08);border:1px solid rgba(255,171,64,.55);color:" + GOLD + ";font-family:Jost,sans-serif;font-size:11px;font-weight:400;letter-spacing:.28em;text-transform:uppercase;cursor:pointer;transition:all .35s;-webkit-tap-highlight-color:transparent}",
    ".ded-go:hover:not(:disabled){background:rgba(255,171,64,.16);letter-spacing:.34em}",
    ".ded-go:disabled{opacity:.35;cursor:default}",

    ".ded-out{margin-top:30px}",
    ".ded-card{border-top:1px solid rgba(246,241,232,.09);padding:24px 0;opacity:0;animation:dedIn .9s ease forwards}",
    "@keyframes dedIn{to{opacity:1}}",
    ".ded-text{font-family:'Cormorant Garamond',serif;font-weight:400;font-style:italic;font-size:22px;line-height:1.6;color:" + CREAM + "}",
    ".ded-copy{margin-top:14px;background:none;border:1px solid rgba(255,171,64,.3);color:rgba(255,171,64,.85);font-family:Jost,sans-serif;font-size:10px;letter-spacing:.24em;text-transform:uppercase;cursor:pointer;padding:8px 16px;transition:all .3s;-webkit-tap-highlight-color:transparent}",
    ".ded-copy:hover{border-color:" + GOLD + ";color:" + GOLD + "}",
    ".ded-copy.ok{border-color:" + GOLD + ";color:" + INK + ";background:" + GOLD + "}",

    ".ded-nota{font-size:13px;font-weight:300;color:rgba(246,241,232,.4);margin-top:22px;line-height:1.7}",
    ".ded-nota a{color:rgba(255,171,64,.8)}",

    ".ded-esperando{display:flex;align-items:center;gap:14px;margin-top:24px}",
    ".ded-esperando svg path{stroke:" + GOLD + ";stroke-width:1;fill:none;stroke-dasharray:14 8;animation:dedFluir 2s linear infinite}",
    "@keyframes dedFluir{to{stroke-dashoffset:-44}}",
    ".ded-esperando span{font-size:12px;font-weight:300;letter-spacing:.1em;color:rgba(246,241,232,.45)}",

    "@media(min-width:700px){",
      "#airosa-dedicatoria{padding:44px 42px 48px}",
      ".ded-title{font-size:38px}",
    "}",
    "@media (prefers-reduced-motion:reduce){.ded-card{animation:none;opacity:1}.ded-esperando svg path{animation:none}}"
  ].join("");
  document.head.appendChild(css);

  host.innerHTML =
    '<div class="ded-eyebrow">Airosa · Tarjeta</div>' +
    '<div class="ded-title">La dedicatoria</div>' +
    '<div class="ded-sub">La pieza dice mucho. La tarjeta dice lo que la pieza no puede. Cuéntanos poco y te proponemos tres versiones.</div>' +
    '<label class="ded-label" for="ded-quien">Para quién es</label>' +
    '<input class="ded-in" id="ded-quien" placeholder="Mi esposa, mi mamá, mi socia..." maxlength="60">' +
    '<label class="ded-label">La ocasión</label>' +
    '<div class="ded-ocs" id="ded-ocs"></div>' +
    '<label class="ded-label" for="ded-detalle">Algo que solo ustedes dos sepan</label>' +
    '<textarea class="ded-ta" id="ded-detalle" placeholder="Un lugar, una fecha, una manía suya, una frase que repiten. Esto es lo que hace que no suene genérica." maxlength="400"></textarea>' +
    '<button class="ded-go" id="ded-go" type="button">Escribir tres versiones</button>' +
    '<div class="ded-out" id="ded-out"></div>';

  var ocs = host.querySelector("#ded-ocs");
  var elegida = "";
  OCASIONES.forEach(function (o) {
    var b = document.createElement("button");
    b.type = "button";
    b.className = "ded-oc";
    b.textContent = o;
    b.onclick = function () {
      elegida = (elegida === o) ? "" : o;
      Array.prototype.forEach.call(ocs.children, function (c) {
        c.classList.toggle("sel", c.textContent === elegida);
      });
    };
    ocs.appendChild(b);
  });

  var go = host.querySelector("#ded-go");
  var out = host.querySelector("#ded-out");

  var ONDA = 'M0 4 q7 -4 14 0 t14 0 t14 0 t14 0 t14 0 t14 0';

  function pedir(prompt) {
    var ctrl = new AbortController();
    var reloj = setTimeout(function () { ctrl.abort(); }, TIMEOUT);
    return fetch(ENDPOINT, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ modo: "dedicatoria", messages: [{ role: "user", content: prompt }] }),
      signal: ctrl.signal
    }).then(function (r) {
      clearTimeout(reloj);
      return r.json();
    }).then(function (d) {
      if (!d.opciones || !d.opciones.length) throw new Error("vacio");
      return d.opciones;
    });
  }

  go.onclick = function () {
    var quien = host.querySelector("#ded-quien").value.trim();
    var detalle = host.querySelector("#ded-detalle").value.trim();

    if (!quien && !elegida && !detalle) {
      out.innerHTML = '<div class="ded-nota">Cuéntanos al menos para quién es.</div>';
      return;
    }

    go.disabled = true;
    go.textContent = "Escribiendo";
    out.innerHTML =
      '<div class="ded-esperando">' +
      '<svg width="84" height="8" viewBox="0 0 84 8"><path d="' + ONDA + '"/></svg>' +
      '<span>Escribiendo tus tres versiones</span></div>';

    var prompt = "Para: " + (quien || "no especificado") +
                 "\nOcasión: " + (elegida || "no especificada") +
                 "\nDetalle personal: " + (detalle || "ninguno");

    // Un intento, y si falla, un reintento automático antes de rendirse.
    pedir(prompt)
      .catch(function () { return pedir(prompt); })
      .then(function (opciones) {
        out.innerHTML = "";
        opciones.forEach(function (t, i) {
          var c = document.createElement("div");
          c.className = "ded-card";
          c.style.animationDelay = (i * 0.18) + "s";
          var p = document.createElement("div");
          p.className = "ded-text";
          p.textContent = t;
          var b = document.createElement("button");
          b.type = "button";
          b.className = "ded-copy";
          b.textContent = "Copiar";
          b.onclick = function () {
            var listo = function () {
              b.textContent = "Copiada";
              b.classList.add("ok");
              setTimeout(function () { b.textContent = "Copiar"; b.classList.remove("ok"); }, 2200);
            };
            if (navigator.clipboard && navigator.clipboard.writeText) {
              navigator.clipboard.writeText(t).then(listo, listo);
            } else {
              // Respaldo para navegadores móviles antiguos
              var ta = document.createElement("textarea");
              ta.value = t;
              document.body.appendChild(ta);
              ta.select();
              try { document.execCommand("copy"); } catch (e) {}
              document.body.removeChild(ta);
              listo();
            }
          };
          c.appendChild(p); c.appendChild(b);
          out.appendChild(c);
        });
        var n = document.createElement("div");
        n.className = "ded-nota";
        n.textContent = "Edítala a tu gusto y pégala en el campo de dedicatoria de arriba.";
        out.appendChild(n);
      })
      .catch(function () {
        out.innerHTML = '<div class="ded-nota">No pudimos generarlas en este momento. Vuelve a intentarlo, o <a href="' + WHATSAPP + '" target="_blank" rel="noopener">escríbenos por WhatsApp</a> y te ayudamos con gusto.</div>';
      })
      .then(function () {
        go.disabled = false;
        go.textContent = "Escribir otras tres";
      });
  };
})();